module.exports = __webpack_public_path__ + "b11d8b704ca20299ac5f9c606576e4a2.svg";